import {
  Button
} from "@material-tailwind/react";
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { IoAdd } from "react-icons/io5";
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FaMinusCircle, FaPlus  } from "react-icons/fa";
import { EditFood } from '../services/foodsServices';
import { fetchFood } from "../redux/slices/foodSlice";
import { toast } from "react-toastify";
import ButtonLoader from "../components/ButtonLoader";


const EditFoodItem = ({ isOpen, onClose, item,}) => {
  const dispatch = useDispatch()
  const [imageFile, setImageFile] = useState(null)
  const [category, setCategory] = useState(null)
  const [loading, setLoading] = useState(false);

  const categories = useSelector((state) => state.category?.category?.data);

  useEffect(() => {
    if (categories?.length > 0) {
      const items = categories.map((item) => item);
      setCategory(items);
    }
  }, [categories]);

  useEffect(() =>{
    dispatch(fetchFood())
  }, [dispatch])

  const formik = useFormik({
    initialValues: {
      name: "",
      categoryId : '',
      price: 0,
      description: "",
      ingredientDetails: "",
      duration: "",
      images: [""],
      videos: [""],
      id: 0,
  },
  validationSchema: Yup.object({
    name: Yup.string().required('Name is required'),
    price: Yup.number().required('Price is required').positive(),
    description: Yup.string().required('Description is required'),
    ingredientDetails: Yup.string().required('ingredientDetails is required'),
    duration: Yup.string().required('duration is required'),
  }),
    onSubmit: async (values) => {
      setLoading(true);

      const res = await EditFood(values)
        if(res.statusCode === 200){
          dispatch(fetchFood(res?.data))
          toast.success(res?.message)
          setLoading(false)
          onClose(false)
        } else if(res?.statusCode === 203){
          toast.error(res.message)
          setLoading(false)
        } else if(res?.statusCode === 404){
          toast.error(res.message)
          setLoading(false)
        } else if(res?.statusCode === 999){
          toast.error(res.message)
          setLoading(false)
        } else {
          console.log(res?.message)
        }
      },
  });

  useEffect(() => {
    if (item) {
      formik.setValues({
        name: item.name,
        categoryId: item.categoryId,
        price: item.price,
        description: item.description,
        ingredientDetails: item.ingredientDetails,
        duration: item.duration,
        images: item.foodImages?.map((img) => img.fileUrl),
        videos: item.foodVideos,
        id: item?.id
      });
    }
  }, [item]);

const handleChangeImage = (e, index) => {
  const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      let newImageFiles = [imageFile];
      newImageFiles[index] = base64String;
      setImageFile(newImageFiles);

      let updatedImages = [...formik.values.images];
      updatedImages[index] = base64String;
      formik.setFieldValue("images", updatedImages);
    }
  reader.readAsDataURL(file);
  }
};

const handleRemoveImage = (index) => {
  let updatedImages = [...formik.values.images];
  updatedImages.splice(index, 1);
  formik.setFieldValue("images", updatedImages);
};


  return (
    <div>
      <Drawer anchor="right" open={isOpen} onClose={onClose} size="md"
         slotProps={{
          root: {
            className: `
              backdrop-blur-[1px] 
              bg-orange/20 
              rounded-tl-2xl 
            `,
          },
        }}  
      >
        <ModalClose />
        <form onSubmit={formik.handleSubmit} className="p-5">
          <p className="capitalize text-[24px] font-bold text-primaryRed pt-5">Edit Food Item</p>
          <p className="mt-2 text-xs text-[#0A0A0ACC]">
          Edit flavor to the menu! Fill in the details to introduce a fresh dish and keep customers coming back for more.        
          </p>
          <div className="mt-3 space-y-4">
            <label>Category</label>
            <div className="my-2">
              <select
                id="categoryId"
                name="categoryId"
                value={formik.values.categoryId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="border text-black border-gray-600 rounded-md px-4 w-full py-1.5"
              >
                <option value="">Select Menu</option>
                {category?.length > 0 ? (
                  category.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    No Menu available
                  </option>
                )}
              </select>
              {formik.touched.categoryId && formik.errors.categoryId ? (
                <div className="text-red-500 text-xs">{formik.errors.categoryId}</div>
              ) : null}
            </div>
            <div className="h-[1px] w-full border-0 bg-primaryGray my-5" />
            <h2 className="text-md">Food Item</h2>
            <p className="text-xs">add upto 5 new food items </p>
            <div className="px-4 py-2 rounded-2xl border my-3">
              <div  className="grid place-items-end">
                <p className="flex items-center text-primaryRed">
                  <IoAdd className="text-lg mr-1 font-bold text-primaryRed"/> 
                  <span className="text-xs">create new food item</span>
                </p>
              </div>
              <div className="my-3">
                <label className='text-md'>Food Items Name</label>
                <input
                  type="text"
                  name="name"
                  onChange={formik.handleChange}
                  defaultValue={formik.values.name}
                  onBlur={formik.handleBlur}
                  placeholder="Input for the food name (e.g., “Jollof Rice”)" 
                  className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-none ring-0 focus:outline-0 placeholder:text-xs px-3"
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-red-500 text-xs">{formik.errors.name}</div>
                ) : null}
              </div>
              <div>
                <label className="text-xs font-semibold py-4">
                  Add Images <span className="font-medium text-gray-500">(you can add up to 4 images)</span>
                </label>
                <div className="flex items-center justify-start gap-4 mt-4 flex-wrap">
                  {Array.from({ length: 4 }).map((_, index) => (
                    <div key={index} className="relative w-[80px] h-[80px] flex flex-col items-center justify-center border rounded-md cursor-pointer overflow-hidden">
                      {formik.values.images[index] ? (
                        <>
                          <img
                            src={formik.values.images[index]}
                            alt={`Uploaded ${index + 1}`}
                            className="w-full h-full object-cover"
                          />
                          <button
                            type="button"
                            onClick={() => handleRemoveImage(index)}
                            className="absolute top-1 right-1 bg-white rounded-full p-1"
                          >
                            <FaMinusCircle className="text-primaryRed text-lg" />
                          </button>
                        </>
                      ) : (
                        <>
                          <FaPlus className="text-gray-500 text-lg" />
                          <input
                            type="file"
                            id={`image-${index}`}
                            name={`image-${index}`}
                            accept="image/*"
                            onChange={(e) => handleChangeImage(e, index)}
                            className="absolute inset-0 opacity-0 cursor-pointer"
                          />
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="my-2">
                <label className='text-md py-2'>Price</label>
                <input
                  type="number"
                  name="price"
                  value={formik.values.price}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  defaultValue={formik.values.price}
                  placeholder=" Input for the item price in Naira (e.g., “₦1500”)." 
                  className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-none ring-0 focus:outline-0 placeholder:text-xs px-3"
                />
                {(formik.touched.price && formik.errors.price) ? (
                    <p className="text-red-500 text-xs">{formik.errors.price}</p>
                  ) : null
                }
              </div>
              <div className="my-2">
                <label className='text-md py-2'>Food Description</label>
                <input
                 type="text"
                 id="description"
                 name="description"
                 value={formik.values.description}
                 onChange={formik.handleChange}
                 defaultValue={formik.values.description}
                 onBlur={formik.handleBlur}
                 placeholder="Short description to describe the food (e.g., “Spicy, flavorful rice cooked in tomato sauce”)." 
                 className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-none ring-0 focus:outline-0 placeholder:text-xs px-3"
               />
               {formik.touched.description && formik.errors.description ? (
                  <div className="text-red-500 text-xs">{formik.errors.description}</div>
                ) : null}
              </div>
              <div className="my-2">
                <label className='text-md py-2'>Food Ingredents</label>
                <input
                 type="text"
                 id="ingredientDetails"
                 name="ingredientDetails"
                 value={formik.values.ingredientDetails}
                 onChange={formik.handleChange}
                 defaultValue={formik.values.ingredientDetails}
                 onBlur={formik.handleBlur}
                 placeholder="Ingredent details" 
                 className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-none ring-0 focus:outline-0 placeholder:text-xs px-3"
               />
               {formik.touched.ingredientDetails && formik.errors.ingredientDetails ? (
                  <div className="text-red-500 text-xs">{formik.errors.ingredientDetails}</div>
                ) : null}
              </div>
              <div className="my-3">
                <label className='text-md py-2'>Duration</label>
                <input
                 type="text"
                 id="duration"
                 name="duration"
                 value={formik.values.duration}
                 onChange={formik.handleChange}
                 defaultValue={formik.values.duration}
                 onBlur={formik.handleBlur}
                 placeholder="2hrs 30mins" 
                 className="border borde-gray-600 rounded-md w-full py-1.5 placeholder:text-gray-400 text-md outline-0 ring-0 focus:outline-0 placeholder:text-xs px-3"
               />
            </div>
            <div className="flex items-center gap-10 justify-between mt-4">
              <Button
                onClick={onClose}
                className="text-primaryRed hover:bg-opacity-50 rounded-md py-2 bg-white w-full outline-none ring-0 border border-primaryRed hover:bg-primaryRed hover:text-white hover:outline-none capitalize mt-6 focus:outline-none"
              >Cancel </Button>
              <Button
                type="submit"
                disabled={loading}
                className="bg-[#FF0000] hover:bg-opacity-50 rounded-md py-2 text-white w-full outline-none ring-0 border border-primaryRed hover:bg-white hover:text-primaryRed hover:outline-none capitalize mt-6 focus:outline-none"
                >
                {loading ? <ButtonLoader />
                : <span>Save</span>
                } 
              </Button>
            </div>
          </div>
          </div>
        </form>  
      </Drawer>
    </div>
  );
}
export default EditFoodItem;